module.exports = __webpack_public_path__ + "static/headline-xl.5609eac2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/headline-xl.jpg
// module id = 475
// module chunks = 114276838955818